import React, { useState } from "react";
import { useSelector } from "react-redux";

import draftLocked from "../../../public/BP_resources/images/icon/locked.svg";
import locked from "../../../public/BP_resources/images/icon/addcheck.svg";
import unlocked from "../../../public/BP_resources/images/icon/unlocked.svg";
import lockedGrey from "../../../public/BP_resources/images/icon/addcheck.svg";
import unlockedGrey from "../../../public/BP_resources/images/icon/unlocked-grey.svg";
import {
  currencyFormat,
  formatCalendarDate,
  formatDate,
  getClientId,
  getCaseId,
  // getCurrentDate,
} from "../../Utils/helper";
import CheckAlreadyRequestedModal from "../CostDashboard/CheckAlreadyRequested";
import EditOfferPopUp from "../Modals/EditOfferModal/EditOfferPopUp";
import SettlementErrorModal from "../Modals/SettlementErrorModal";
import SettlementNoCheckModal from "../Modals/SettlementNoCheckModal";
import SettlementCheckRequest from "../Modals/SettlementCheckRequest";
import GenericSettlementAddPopup from "../Modals/GenericSettlementAddPopup";
import EditSettlementTrustLedgerCheckPopup from "../Modals/EditSettlementTrustLedgerCheckPopup";

import updateLockSettleValue from "./common/updateLockSettleValue";
import updateLockSettleAmount from "./common/updateLockSettleAmount";
import SettlementCurrencyInput, {
  getSettlementCurrencyInputSum,
} from "./common/SettlementCurrencyInput";
import AllLockSettle from "./common/AllLockSettle";
import ChequeUpload from "./ChequeUpload";
import generateCheckOffer from "./api/generateCheckOffer";
import CopyValueSettlement from "./common/CopyValueSettlement";
import updateRightColumnValue from "./common/updateRightColumnValue";
import SectionActionBar from "./SectionActionBar";
import SettlementCheckDetails from "./common/SettlementCheckDetails";
import {
  getRemainingOfferCheckAmount,
  hasNonZeroSettlementAmount,
  hasSettlementCheck,
} from "./common/settlementCheckGuards";

const SettlementRecentOffers = ({
  offersObj,
  updateClientProceedStates,
  feesObj,
  trustLedgerObj,
  offerCombinations,
  updateGroupedOffersState,
  settlementObjProps,
}) => {
  const [showSettlementPopup, setShowSettlementPopup] = useState(false);
  const { updateFeesState } = feesObj;
  const { updateTrustLedger } = trustLedgerObj;
  const [currentCheck, setCheck] = useState({});
  const [showModal, showEditCostModal] = useState(false);
  const [checkAlreadyRequested, setCheckAlreadyRequested] = useState(false);
  const handleCheckAlreadyRequestedClose = () => setCheckAlreadyRequested(false);
  const handleCheckedRowClick = (event) => {
    event?.stopPropagation();
    setCheckAlreadyRequested(true);
  };
  const [showCheckRequestModal, setCheckRequestModal] = useState(false);
  const handleCheckRequestClose = () => setCheckRequestModal(false);
  const [currentOfferCheckAmount, setCurrentOfferCheckAmount] = useState(0);

  const lockAllOffers = (bType, boolVal) => {
    AllLockSettle("offer", bType, boolVal);
    if (bType === "draft1") {
      setOffersLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isDraftLocked: hasOfferCheckById(row.id) ? row.isDraftLocked : boolVal === "true",
        }))
      );
    } else {
      setOffersLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isFinalLocked: hasOfferCheckById(row.id) ? row.isFinalLocked : boolVal === "true",
        }))
      );
    }
  };
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  // const caseSummary = useSelector((state) => state?.caseData?.summary);
  const handleFinalLockChange = (id, sectionName, event) => {
    event.stopPropagation();
    if (hasOfferCheckById(id)) {
      handleCheckedRowClick(event);
      return;
    }
    updateLockSettleValue(id, "offer", "final");
    setOffersLocks((prevStates) =>
      prevStates.map((row) => (row.id === id ? { ...row, isFinalLocked: !row.isFinalLocked } : row))
    );
  };
  const handleDraftLockChange = (id, event) => {
    event.stopPropagation();
    if (hasOfferCheckById(id)) {
      handleCheckedRowClick(event);
      return;
    }
    updateLockSettleValue(id, "offer", "draft1");
    setOffersLocks((prevStates) =>
      prevStates.map((row) => (row.id === id ? { ...row, isDraftLocked: !row.isDraftLocked } : row))
    );
  };
  const [msgError, _setMsgError] = useState("");
  const [_isHovered, setIsHovered] = useState({ id: -1, value: false });
  const [showNoCheckModal, setNoCheckModal] = useState(false);
  const handleNoCheckClose = () => setNoCheckModal(false);
  const handleNoCheckShow = () => setNoCheckModal(true);

  const {
    offersLocks,
    setOffersLocks,
    groupedOffers,
    offers,
    // offerFinalAmount,
    setOfferLockValues,
    offerLockValues,
    showOfferModal,
    handleOfferClose,
    handleOfferShow,
    currentOffer,
    setCurrentOffer,
    showErrorModal,
    handleErrorClose,
    handleErrorShow: _handleErrorShow,
    updateOffersState,
    offerAcceptedAmount,
    offerRemainingAmount,
    acceptedDraftnFinalValues,
  } = offersObj;
  // eslint-disable-next-line unused-imports/no-unused-vars
  let totalChecksAmount = 0.0;
  // eslint-disable-next-line unused-imports/no-unused-vars
  const totalOffersAmount = offers?.reduce((acc, offer) => {
    totalChecksAmount += offer.checks?.reduce(
      (acc, check) => parseFloat(acc) + parseFloat(check?.amount || 0.0),
      0.0
    );
    return offer?.offer_type.name === "Offer"
      ? parseFloat(acc) + parseFloat(offer?.amount || 0.0)
      : parseFloat(acc) + parseFloat(offer?.demand || 0.0);
  }, 0.0);
  // const totalTrustDeposit = offerFinalAmount - totalChecksAmount;
  const recentOffers = groupedOffers.map((group) => group.offers_list?.[0]).filter(Boolean);
  const getOfferLock = (offerId) => offersLocks.find((lock) => lock.id === offerId);
  const hasOfferCheck = (offer) =>
    hasSettlementCheck(getOfferLock(offer?.id)) || hasSettlementCheck(offer);

  const hasOfferCheckById = (offerId) =>
    hasOfferCheck(
      recentOffers.find((offer) => offer.id === offerId) ||
        offers.find((offer) => offer.id === offerId)
    );
  const getOfferAmount = (offer) =>
    offer?.offer_type?.id === 8 ? offer?.demand || 0.0 : offer?.amount || 0.0;
  const refreshOfferState = () => {
    updateOffersState();
    updateGroupedOffersState();
    updateClientProceedStates();
    updateFeesState();
    updateTrustLedger();
  };
  const handleOfferCheckRequestConfirm = async (values) => {
    const name =
      currentOffer?.offer_type?.id === 8
        ? currentOffer?.by_entity_client
          ? `${currentOffer.by_entity_client.first_name || ""} ${currentOffer.by_entity_client.last_name || ""}`.trim()
          : currentOffer?.by_defendant
            ? currentOffer.by_defendant.defendantType?.id === 1
              ? `${currentOffer.by_defendant.first_name || ""} ${currentOffer.by_defendant.last_name || ""}`.trim()
              : currentOffer.by_defendant.entity_name || ""
            : ""
        : currentOffer?.entity_client
          ? `${currentOffer.entity_client.first_name || ""} ${currentOffer.entity_client.last_name || ""}`.trim()
          : currentOffer?.defendant
            ? currentOffer.defendant.defendantType?.id === 1
              ? `${currentOffer.defendant.first_name || ""} ${currentOffer.defendant.last_name || ""}`.trim()
              : currentOffer.defendant.entity_name || ""
            : "";
    const payload = {
      client_id: parseInt(getClientId()),
      case_id: parseInt(getCaseId()),
      linked_offer_for_check: currentOffer?.id,
      mark_deposit: "off",
      check_amount: parseFloat(values?.amount || currentOfferCheckAmount || 0),
      payee: name || "",
      memo: values?.memo || "",
      check_number: values?.check_number || "",
      check_date: values?.check_date || "",
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zip: values.zip,
      phone: values.phone,
      extension: values.extension,
      fax: values.fax,
      email: values.email,
      website: values.website,
    };
    await generateCheckOffer(payload);
  };

  return (
    <>
      <div className="m-b-5">
        <SectionActionBar sectionName={"Negotiation"} />
        <div className="table--no-card rounded-0 border-0 w-100">
          <table className="table table-borderless table-striped table-earning settlement-table">
            <thead>
              <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                <th />
                <th className="td-autosize text-center">Negotiating Parties</th>
                <th
                  style={{
                    minWidth: "20px",
                    width: "20px",
                    maxWidth: "20px",
                  }}
                />
                <th className="td-autosize text-center">Most Recent Activity</th>
                <th className="td-autosize text-center">Accepted</th>
                {/* <th className='td-autosize text-end'>Amount</th> */}
                <th className="" />
                <th
                  className={`text-end td-autosize ${offersLocks.some((lock) => !lock.isDraftLocked) ? "cursor-default" : ""}`}
                  // style={{color:"var(--primary-25) !important"}}
                  onClick={() => {
                    const draftLockCheck = recentOffers.some((offer) => {
                      const lock = getOfferLock(offer.id);
                      return !lock?.isDraftLocked && !hasOfferCheck(offer);
                    });
                    if (draftLockCheck) {
                      recentOffers.forEach((offer) => {
                        const lock = getOfferLock(offer.id);
                        if (!lock?.isDraftLocked && !hasOfferCheck(offer)) {
                          updateRightColumnValue(
                            lock?.isDraftLocked,
                            lock?.isFinalLocked,
                            setOffersLocks,
                            "offer-draft",
                            offer.id,
                            offerLockValues,
                            setOfferLockValues,
                            "offer",
                            "draft1",
                            getOfferAmount(offer)
                          );
                        }
                      });
                      updateOffersState();
                      updateClientProceedStates();
                    }
                  }}
                >
                  <span className="d-flex align-items-center justify-content-end position-relative center-val-div">
                    {recentOffers.some((offer) => {
                      const lock = getOfferLock(offer.id);
                      return !lock?.isDraftLocked && !hasOfferCheck(offer);
                    }) && <CopyValueSettlement />}
                    Amount
                  </span>
                </th>
                <th
                  className={`text-end s-draft ${offersLocks?.some((lock) => lock.isDraftLocked && !lock.isFinalLocked) ? "cursor-default" : ""}`}
                  style={{ color: "var(--primary-25) !important" }}
                  onClick={() => {
                    const finalLockCheck = recentOffers.some((offer) => {
                      const lock = getOfferLock(offer.id);
                      return lock?.isDraftLocked && !lock?.isFinalLocked && !hasOfferCheck(offer);
                    });
                    if (finalLockCheck) {
                      recentOffers.forEach((offer) => {
                        const lock = getOfferLock(offer.id);
                        if (lock?.isDraftLocked && !lock?.isFinalLocked && !hasOfferCheck(offer)) {
                          updateRightColumnValue(
                            lock?.isDraftLocked,
                            lock?.isFinalLocked,
                            setOffersLocks,
                            "offer-final",
                            offer.id,
                            offerLockValues,
                            setOfferLockValues,
                            "offer",
                            "final",
                            lock?.isDraftAmount
                          );
                        }
                      });
                      updateOffersState();
                      updateClientProceedStates();
                    }
                  }}
                >
                  <div className="central-header-div d-flex justify-content-between align-items-center height-25">
                    <div className="d-flex align-items-center position-relative">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19 lock-icon"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllOffers("draft1", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19 lock-icon"
                        alt="lock-icon"
                        src={draftLocked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllOffers("draft1", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span
                      className="d-flex align-items-center justify-content-end position-relative center-val-div draft-central-div"
                      style={{ paddingRight: "2px" }}
                    >
                      {offersLocks?.some(
                        (lock) =>
                          lock.isDraftLocked && !lock.isFinalLocked && !hasOfferCheckById(lock.id)
                      ) && <CopyValueSettlement />}
                      <span className="position-absolute right-0">Draft</span>
                    </span>
                  </div>
                </th>
                <th className="text-end s-final" style={{ color: "var(--primary-25) !important" }}>
                  <div className="d-flex justify-content-between align-items-center height-25">
                    <div className="d-flex align-items-center">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllOffers("final", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19"
                        alt="lock-icon"
                        src={locked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllOffers("final", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span style={{ paddingRight: "2px" }}>Final</span>
                  </div>
                </th>
                <th className="s-verify" />
                <th
                  className="td-autosize check-request--btn-settle text-center"
                  style={{ color: "var(--primary-25) !important" }}
                >
                  Check
                </th>
              </tr>
            </thead>
            <tbody id="body-table">
              <>
                {offers?.length > 0 &&
                  groupedOffers.map((group, parentIndex) => {
                    if (group.offers_list?.length === 0) return null; // Skip empty groups
                    const offer = group.offers_list[0]; // Get only the first offer
                    const offerAmount = getOfferAmount(offer);
                    const offerLock = getOfferLock(offer.id);
                    const remainingCheckAmount = getRemainingOfferCheckAmount(offer, offerLock);

                    return (
                      <React.Fragment key={parentIndex}>
                        <tr
                          className="cursor-default"
                          onClick={() => {
                            setCurrentOffer(offer);
                            handleOfferShow();
                          }}
                        >
                          <td className="">{parentIndex + 1}</td>
                          {/* Negotiating Parties */}
                          <td className="td-autosize">
                            <div className="d-flex flex-column align-items-start">
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  gap: "5px",
                                }}
                              >
                                <span className="d-flex align-items-center">
                                  <i className={"ic ic-15 ic-client"} />
                                </span>
                                <span className="">
                                  {offer?.by_entity_client
                                    ? `${offer?.by_entity_client?.first_name || ""} ${offer?.by_entity_client?.last_name || ""}`
                                    : offer?.entity_client
                                      ? `${offer?.entity_client?.first_name || ""} ${offer?.entity_client?.last_name || ""}`
                                      : ""}
                                  {/* {offer?.by_entity_client
                                    ? `${offer?.by_entity_client?.first_name || ""} ${offer?.by_entity_client?.last_name || ""}`
                                    : offer?.by_defendant
                                      ? offer?.by_defendant?.defendantType?.id === 1
                                        ? `${offer?.by_defendant?.first_name || ""} ${offer?.by_defendant?.last_name || ""}`
                                        : offer?.by_defendant?.entity_name || ""
                                      : ""} */}
                                </span>
                                <span className="color-primary">vs</span>
                              </div>
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  gap: "5px",
                                }}
                              >
                                <span className=" d-flex align-items-center">
                                  <i className={"ic ic-15 ic-defendants"} />
                                </span>
                                <span>
                                  {offer?.by_defendant
                                    ? offer?.by_defendant?.defendantType?.id === 1
                                      ? `${offer?.by_defendant?.first_name || ""} ${offer?.by_defendant?.last_name || ""}`.trim()
                                      : offer?.by_defendant?.entity_name || ""
                                    : offer?.defendant
                                      ? offer?.defendant?.defendantType?.id === 1
                                        ? `${offer?.defendant?.first_name || ""} ${offer?.defendant?.last_name || ""}`.trim()
                                        : offer?.defendant?.entity_name || ""
                                      : ""}
                                </span>

                                {(offer?.by_defendant ? offer?.by_insurance : offer?.insurance) && (
                                  <span className="d-flex align-items-center justify-content-center">
                                    <i className={"ic ic-15 ic-insurance"} />
                                  </span>
                                )}
                                {(offer?.by_defendant ? offer?.by_insurance : offer?.insurance) && (
                                  <span>
                                    {offer?.by_defendant
                                      ? offer?.by_insurance?.company
                                      : offer?.insurance?.company}
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td />
                          {/* Most Recent Activity */}
                          <td className="td-autosize">
                            <div className="d-flex flex-column align-items-start">
                              {offer?.recent_party_offers?.map((of) => {
                                return (
                                  <div className="d-flex align-items-center">
                                    {/* <span>{formatDate(offer?.date)}</span>
                                     */}
                                    <span>{formatDate(of?.date)}</span>
                                    <span className="m-l-5 m-r-5">
                                      {of?.offer_type?.name === "Settlement Conference" ||
                                      of?.offer_type?.name === "Mediation"
                                        ? `${of?.offer_type?.name} Offer`
                                        : of?.offer_type?.name}
                                    </span>

                                    <span className="">By</span>
                                    <span className="m-l-5 m-r-5 d-flex align-items-center">
                                      {of?.entity_type === "Client" ? (
                                        <i className={"ic ic-15 ic-client"} />
                                      ) : (
                                        <i className={"ic ic-15 ic-defendants"} />
                                      )}
                                    </span>
                                    <span>{of?.entity}</span>
                                    <span className="m-l-5">{currencyFormat(of?.amount)}</span>
                                  </div>
                                );
                              })}
                            </div>
                          </td>

                          {/* Accepted Date */}
                          <td className="text-center dollar-amount-value td-autosize">
                            {offer?.accepted && `${formatCalendarDate(offer?.accepted_date)}`}
                          </td>
                          <td className="" onClick={(e) => e.stopPropagation()} />
                          {/* Amount */}
                          <td
                            className="text-end monospace-font td-autosize dollar-amount-value"
                            data-value={offerAmount}
                          >
                            <span
                              className={`d-flex align-items-center ${!offersLocks.find((row) => row.id === offer.id)?.isDraftLocked && !hasOfferCheck(offer) ? "justify-content-between cursor-default" : "justify-content-end"} align-items-center position-relative center-val-div`}
                              onClick={(e) => {
                                e.stopPropagation();
                                const lock = offersLocks.find((row) => row.id === offer.id);
                                if (hasOfferCheck(offer)) {
                                  handleCheckedRowClick(e);
                                  return;
                                }
                                updateRightColumnValue(
                                  lock?.isDraftLocked,
                                  lock?.isFinalLocked,
                                  setOffersLocks,
                                  "offer-draft",
                                  offer.id,
                                  offerLockValues,
                                  setOfferLockValues,
                                  "offer",
                                  "draft1",
                                  offerAmount
                                );
                                updateOffersState();
                                updateClientProceedStates();
                              }}
                            >
                              <span className="d-inline-block">
                                {!offersLocks.find((row) => row.id === offer.id)?.isDraftLocked &&
                                  !hasOfferCheck(offer) && <CopyValueSettlement />}
                              </span>
                              {currencyFormat(offerAmount)}
                            </span>
                          </td>
                          {/* Draft */}
                          <td
                            className="s-draft text-end"
                            onClick={(e) => {
                              e.stopPropagation();
                              const lock = offersLocks.find((row) => row.id === offer.id);
                              if (hasOfferCheck(offer)) {
                                handleCheckedRowClick(e);
                                return;
                              }
                              updateRightColumnValue(
                                lock?.isDraftLocked,
                                lock?.isFinalLocked,
                                setOffersLocks,
                                "offer-final",
                                offer.id,
                                offerLockValues,
                                setOfferLockValues,
                                "offer",
                                "final",
                                lock?.isDraftAmount
                              );
                              updateOffersState();
                              updateClientProceedStates();
                            }}
                          >
                            <div className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div">
                              <span className="d-flex align-items-center justify-content-center">
                                {!hasOfferCheck(offer) && (
                                  <img
                                    onClick={(e) => handleDraftLockChange(offer.id, e)}
                                    id="lock-image"
                                    className="ic ic-15"
                                    src={
                                      offersLocks.find((row) => row.id === offer.id)?.isDraftLocked
                                        ? draftLocked
                                        : unlocked
                                    }
                                    alt="lock-icon"
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                              </span>

                              <SettlementCurrencyInput
                                id="lock-input"
                                className={`${offersLocks.find((row) => row.id === offer.id)?.isDraftLocked && !offersLocks.find((row) => row.id === offer.id)?.isFinalLocked ? "cursor-pointer" : ""} monospace-font text-end offer-draft-${offer.id} offer-draft dollar-amount-value ${offersLocks.find((row) => row.id === offer.id)?.isDraftLocked || hasOfferCheck(offer) ? "locked-input" : "unlock-input"}`}
                                value={offer.draft1}
                                readOnly={
                                  offersLocks.find((row) => row.id === offer.id)?.isDraftLocked ||
                                  hasOfferCheck(offer)
                                }
                                onClick={(e) => {
                                  // e.stopPropagation();
                                  if (hasOfferCheck(offer)) {
                                    handleCheckedRowClick(e);
                                    return;
                                  }
                                  e.target.focus();
                                }}
                                onLocalChange={({ dataValue }) => {
                                  if (hasOfferCheck(offer)) return;
                                  setOffersLocks((prevStates) =>
                                    prevStates.map((row) =>
                                      row.id === offer?.id
                                        ? { ...row, isDraftAmount: dataValue }
                                        : row
                                    )
                                  );
                                  const sum = getSettlementCurrencyInputSum("offer-draft");
                                  setOfferLockValues((prevValues) => [sum, prevValues[1]]);
                                }}
                                onDebouncedCommit={async ({ submitValue }) => {
                                  if (hasOfferCheck(offer)) return;
                                  await updateLockSettleAmount(
                                    offer.id,
                                    "offer",
                                    "draft1",
                                    submitValue
                                  );
                                  updateOffersState();
                                  updateClientProceedStates();
                                }}
                                onMouseEnter={(e) => {
                                  e.stopPropagation();
                                  const lock = offersLocks.find((row) => row.id === offer.id);
                                  if (
                                    lock?.isDraftLocked &&
                                    !lock?.isFinalLocked &&
                                    !hasOfferCheck(offer)
                                  ) {
                                    const container = e.currentTarget.closest(".center-val-div");
                                    const lockImg = container?.querySelector("#lock-image");
                                    const copyEl = container?.querySelector(
                                      ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                    );
                                    if (lockImg) {
                                      lockImg.style.opacity = 0;
                                      lockImg.style.zIndex = 0;
                                      // lockImg.style.width = 0;
                                    }
                                    if (copyEl) {
                                      copyEl.style.opacity = 1;
                                      copyEl.style.zIndex = 3;
                                      copyEl.style.cursor = "pointer";
                                      copyEl.style.display = "flex";
                                      // copyEl.style.width = "max-content";
                                    }
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  const lock = offersLocks.find((row) => row.id === offer.id);
                                  if (
                                    lock?.isDraftLocked &&
                                    !lock?.isFinalLocked &&
                                    !hasOfferCheck(offer)
                                  ) {
                                    const container = e.currentTarget.closest(".center-val-div");
                                    const lockImg = container?.querySelector("#lock-image");
                                    const copyEl = container?.querySelector(
                                      ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                    );
                                    if (lockImg) {
                                      lockImg.style.opacity = 1;
                                      lockImg.style.zIndex = 1;
                                    }
                                    if (copyEl) {
                                      copyEl.style.opacity = 0;
                                      copyEl.style.zIndex = 0;
                                      copyEl.style.cursor = "initial";
                                      copyEl.style.display = "none";
                                    }
                                  }
                                }}
                                style={{ zIndex: 2 }}
                              />
                              {offersLocks.find((row) => row.id === offer.id)?.isDraftLocked &&
                                !offersLocks.find((row) => row.id === offer.id)?.isFinalLocked &&
                                !hasOfferCheck(offer) && <CopyValueSettlement draft={true} />}
                            </div>
                          </td>
                          {/* Final */}
                          <td className="s-final">
                            <div
                              onMouseEnter={() => setIsHovered({ id: offer.id, value: true })}
                              onMouseLeave={() => setIsHovered({ id: offer.id, value: false })}
                              className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                            >
                              <span className="d-flex align-items-center m-r-5">
                                <img
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    handleFinalLockChange(offer.id, "offers", e);
                                  }}
                                  id="lock-image"
                                  className={`ic ic-15 ${offersLocks.find((row) => row.id === offer.id)?.checkID?.check_sent ? "invisible" : ""}`}
                                  src={
                                    offersLocks.find((row) => row.id === offer.id)?.isFinalLocked
                                      ? offersLocks.find((row) => row.id === offer.id)?.checkID
                                          ?.check_sent
                                        ? lockedGrey
                                        : locked
                                      : offersLocks.find((row) => row.id === offer.id)?.checkID
                                            ?.check_sent
                                        ? unlockedGrey
                                        : unlocked
                                  }
                                  alt="lock-icon"
                                  style={{ cursor: "pointer" }}
                                />
                              </span>

                              <SettlementCurrencyInput
                                id="lock-input"
                                className={`${!hasOfferCheck(offer) && offersLocks.find((row) => row.id === offer.id)?.isFinalLocked ? "cursor-pointer" : ""} monospace-font text-end offer-final-${offer.id} offer-final dollar-amount-value ${offersLocks.find((row) => row.id === offer.id)?.isFinalLocked || hasOfferCheck(offer) ? "locked-input" : "unlock-input"}`}
                                value={offer.final}
                                readOnly={
                                  offersLocks.find((row) => row.id === offer.id)?.isFinalLocked ||
                                  hasOfferCheck(offer)
                                }
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  // const lock = offersLocks.find((row) => row.id === offer.id);
                                  if (hasOfferCheck(offer)) {
                                    handleCheckedRowClick(e);
                                    return;
                                  }
                                  // if (lock?.isFinalLocked) {
                                  //   setCurrentOffer(offer);
                                  //   setCurrentOfferCheckAmount(lock?.isFinalAmount || 0);
                                  //   setCheckRequestModal(true);
                                  // }
                                }}
                                onLocalChange={({ dataValue }) => {
                                  if (hasOfferCheck(offer)) return;
                                  setOffersLocks((prevStates) =>
                                    prevStates.map((row) =>
                                      row.id === offer?.id
                                        ? { ...row, isFinalAmount: dataValue }
                                        : row
                                    )
                                  );
                                  const sum = getSettlementCurrencyInputSum("offer-final");
                                  setOfferLockValues((prevValues) => [prevValues[0], sum]);
                                }}
                                onDebouncedCommit={async ({ submitValue }) => {
                                  if (hasOfferCheck(offer)) return;
                                  await updateLockSettleAmount(
                                    offer.id,
                                    "offer",
                                    "final",
                                    submitValue
                                  );
                                  updateGroupedOffersState();
                                  updateClientProceedStates();
                                }}
                              />
                              {!hasOfferCheck(offer) &&
                                offersLocks.find((row) => row.id === offer.id)?.isFinalLocked &&
                                hasNonZeroSettlementAmount(
                                  offersLocks.find((row) => row.id === offer.id)?.isFinalAmount
                                ) && <CopyValueSettlement draft={true} final={true} />}
                            </div>
                          </td>
                          <td className="s-verify" onClick={(e) => e.stopPropagation()}>
                            <ChequeUpload
                              entity={offer}
                              panel={"offer"}
                              pageId={page_id_click_record}
                              documentType="verify"
                              updateStates={updateOffersState}
                              handleNoCheckShow={handleNoCheckShow}
                            />
                          </td>
                          <td
                            className="td-autosize  text-center"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="d-flex justify-content-center">
                              {offer?.accepted &&
                                offerLock?.isFinalLocked &&
                                remainingCheckAmount > 0 && (
                                  <div className="d-flex align-items-center justify-content-center">
                                    <button
                                      type="button"
                                      aria-label="Deposit Settlement Check"
                                      onClick={() => {
                                        setCurrentOffer(offer);
                                        setCurrentOfferCheckAmount(remainingCheckAmount);
                                        setCheckRequestModal(true);
                                      }}
                                      className="btn settlement-deposit-check-btn"
                                    >
                                      Deposit Settlement Check
                                    </button>
                                  </div>
                                )}
                            </div>
                          </td>
                        </tr>

                        {offer?.checks?.length > 0 &&
                          offer?.checks?.map((check) => {
                            return (
                              <tr
                                className="cursor-default"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCurrentOffer(offer);
                                  setCheck(check);
                                  showEditCostModal(true);
                                }}
                              >
                                <td />
                                <td className="height-25 text-capitalize text-end" colSpan={6}>
                                  <span className="whitespace-SETTLE primary-clr-25">
                                    {check?.deposit
                                      ? "Trust Deposit Check: "
                                      : "Settlement Check: "}
                                  </span>
                                  <p
                                    className="d-inline-flex align-items-center height-25 monospace-font text-end fw-bold dollar-amount-value"
                                    data-value={check?.amount || 0.0}
                                  >
                                    {currencyFormat(check?.amount || 0.0)}
                                  </p>
                                </td>
                                <td className="s-draft text-end" />
                                <td className="s-final" />
                                <td className="s-verify">
                                  <ChequeUpload
                                    entity={{
                                      id: offer?.id,
                                      checkID: check,
                                    }}
                                    panel={"other"}
                                    pageId={page_id_click_record}
                                    documentType="verify"
                                    updateStates={updateOffersState}
                                    handleNoCheckShow={handleNoCheckShow}
                                  />
                                </td>
                                <td
                                  className="td-autosize  text-center"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="d-flex justify-content-center">
                                    <SettlementCheckDetails
                                      entity={{
                                        id: offer?.id,
                                        checkID: check,
                                      }}
                                      check={check}
                                      pageId={page_id_click_record}
                                      updateStates={updateOffersState}
                                      handleNoCheckShow={handleNoCheckShow}
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}

                        <tr className="cursor-default">
                          <td
                            className="height-33 text-end td-autosize whitespace-SETTLE primary-clr-25"
                            colSpan={6}
                          />
                          <td className="monospace-font td-autosize text-end whitespace-SETTLE dollar-amount-value" />
                          <td className="monospace-font text-end" />
                          <td className="monospace-font text-end" />
                          <td className="s-verify" />
                          <td className="td-autosize " />
                        </tr>
                      </React.Fragment>
                    );
                  })}

                {offers?.length > 0 && (
                  <tr className="cursor-default">
                    <td />
                    <td className="height-25 text-capitalize text-end" colSpan={6}>
                      <span className="whitespace-SETTLE primary-clr-25">
                        Accepted Settlement:{" "}
                      </span>
                      <p
                        className="d-inline-flex align-items-center height-25 monospace-font text-end fw-bold dollar-amount-value"
                        data-value={offerAcceptedAmount || 0.0}
                      >
                        {currencyFormat(offerAcceptedAmount || 0.0)}
                      </p>
                    </td>
                    <td className="s-draft monospace-font text-end">
                      <span
                        style={{ paddingRight: "2px" }}
                        data-value={acceptedDraftnFinalValues[0] || 0.0}
                        className="dollar-amount-value"
                      >
                        {currencyFormat(acceptedDraftnFinalValues[0] || 0.0)}
                      </span>
                    </td>
                    <td className="s-final monospace-font text-end">
                      <span
                        style={{ paddingRight: "2px" }}
                        data-value={acceptedDraftnFinalValues[1] || 0.0}
                        className="dollar-amount-value"
                      >
                        {currencyFormat(acceptedDraftnFinalValues[1] || 0.0)}
                      </span>
                      {/* <span
                        style={{ paddingRight: "2px" }}
                        data-value={offerAcceptedAmount || 0.0}
                        className="dollar-amount-value"
                      >
                        {currencyFormat(offerAcceptedAmount || 0.0)}
                      </span> */}
                    </td>
                    <td className="s-verify" />
                    <td className="td-autosize " />
                  </tr>
                )}
                {offers?.length > 0 && (
                  <tr className="cursor-default">
                    <td />
                    <td className="height-25 text-capitalize text-end" colSpan={6}>
                      <span className="whitespace-SETTLE primary-clr-25">
                        Settlement Remaining For Assignment:{" "}
                      </span>
                      <p
                        className="d-inline-flex align-items-center height-25 monospace-font text-end fw-bold dollar-amount-value"
                        data-value={offerRemainingAmount || 0.0}
                      >
                        {/* {currencyFormat(totalTrustDeposit || 0.0)} */}
                        {currencyFormat(offerRemainingAmount || 0.0)}
                      </p>
                    </td>
                    <td className="s-draft monospace-font text-end" />
                    <td className="s-final monospace-font text-end" />
                    <td className="s-verify" />
                    <td className="td-autosize" />
                  </tr>
                )}
              </>
            </tbody>
          </table>
        </div>
      </div>
      {showSettlementPopup && (
        <GenericSettlementAddPopup
          show={showSettlementPopup}
          handleClose={() => {
            setShowSettlementPopup(false);
          }}
          _initialLabel={"An Initial Demand or Offer"}
          {...settlementObjProps}
        />
      )}
      {showModal && (
        <EditSettlementTrustLedgerCheckPopup
          onHide={() => {
            showEditCostModal(false);
            updateOffersState();
          }}
          isVisible={showModal}
          check={currentCheck}
          offer={currentOffer}
          checks={currentOffer.checks}
          setCurrentCheck={setCheck}
          fetchAccountsData={updateOffersState}
        />
      )}
      {showOfferModal && (
        <EditOfferPopUp
          show={showOfferModal}
          updateGroupedOffersState={updateGroupedOffersState}
          handleClose={handleOfferClose}
          offer={currentOffer}
          updateFeesState={updateFeesState}
          updateOffersState={updateOffersState}
          updateClientProceedStates={updateClientProceedStates}
          updateTrustLedger={updateTrustLedger}
          offerCombinations={offerCombinations}
        />
      )}
      {showNoCheckModal && (
        <SettlementNoCheckModal show={showNoCheckModal} handleClose={handleNoCheckClose} />
      )}
      {checkAlreadyRequested && (
        <CheckAlreadyRequestedModal
          show={checkAlreadyRequested}
          hideModal={handleCheckAlreadyRequestedClose}
        />
      )}
      {showCheckRequestModal && (
        <SettlementCheckRequest
          show={showCheckRequestModal}
          handleClose={handleCheckRequestClose}
          finalAmount={currentOfferCheckAmount}
          panelLabel={"Offer"}
          panelName={"offer"}
          depositSettlementCheck={true}
          panelEntity={currentOffer}
          updateStates={refreshOfferState}
          onConfirm={handleOfferCheckRequestConfirm}
        />
      )}
      {showErrorModal && (
        <SettlementErrorModal
          show={showErrorModal}
          handleClose={handleErrorClose}
          errorMsg={msgError}
        />
      )}
    </>
  );
};

export default SettlementRecentOffers;
